<template>
<!--  卡券详情-->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基础信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex" justify="space-between">
            <a-col v-for="(item, index) of infoList" :key="index" v-bind="$store.state.advanced_colWidth">
              <a-form-item :label="item.label">
                <span class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form>

    <div class="card">
      <div class="card-head">
        <h3>卡券列表</h3>
      </div>
      <div class="card-body">
        <!--删除列表时使用的是rowKey的id-->
        <x-tabula
          ref="table"
          rowKey="id"
          :initReqHandle="false"
          :dataSource="dataSource"
          :searchList="searchList"
          :columns="columns"
          :tableOptList="tableOptList"
          :rowOptList="[]"
          :searchParams.sync="searchParams"
          :listApi="listApi"
          :addHandleParam="addHandleParam"
          :deleteParam="deleteParam"
          :rowSelection="false"
        >
          <template slot="opt_status" slot-scope="{row}">
            <span>{{couponStatus[row.status]}}</span>
          </template>
          <template slot="opt_user" slot-scope="{row}">
            <a-button @click="toUserDetail(row)" v-if="row.userId" type="link">{{ row.receiveUser }}</a-button>
            <span v-else>{{ row.receiveUser }}</span>
          </template>
        </x-tabula>
      </div>
    </div>

    <!--添加卡券的弹窗-->
    <a-modal
      title="添加卡券"
      :visible="visible"
      @cancel="visible=false"
      @ok="$refs.addEdit.handleSubmit()"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
      width="650px"
    >
      <a-form v-bind="$store.state.base_itemLayout">
        <a-form-item label="下载模板">
          <a-button @click="downTemplate" type="primary">点击下载</a-button>
        </a-form-item>
      </a-form>

      <x-addEdit
        ref="addEdit"
        formType="modal"
        :isSubmitBtn="false"
        :reqLoading="btnLoading"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
      />
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'couponDetail',
  data () {
    return {
      queryParam: {},
      couponStatus: ['未发放', '已发放', '作废'], // 0.未发放, 1.已发放, 2作废
      infoList: [
        { label: '卡券名称', key: 'name', value: undefined },
        { label: '有效时间', key: 'expireTime', value: undefined }
      ],

      visible: false,
      btnLoading: { loading: false },
      formList: [
        {
          label: '选择文件',
          inputType: 'upload',
          options: [],
          handle: '',
          placeholder: '',
          fileList: [],
          beforeHandle: this.beforeHandle,
          uploadParam: {
            url: '',
            accept: this.$store.state.excelAccept
          },
          props: ['file', {
            rules: [{required: true, message: '请选择文件'}]
          }]
        }
      ],
      formKey: {
        name: undefined
      },
      addParam: {
        url: '',
        reqHandle: this.reqHandle,
        resHandle: this.addResHandle
      },

      searchList: [
        { props: ['keywords'], placeholder: '手机号、卡券', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '导出数据', handle: this.exportData, icon: 'download', permi: ['community:couponDetail:export'] },
        { text: '添加卡劵', handle: this.toAddCoupon, icon: 'plus', permi: ['community:couponDetail:add'] }
      ],
      couponColumns: [
        { title: '券码', dataIndex: 'couponCode', align: '', width: '' }
      ],
      pwdColumns: [
        { title: '卡号', dataIndex: 'couponCode', align: '', width: '' },
        { title: '密码', dataIndex: 'password', align: '', width: '' }
      ],
      columns: [
        { title: '状态', dataIndex: 'status', align: '', width: '', scopedSlots: { customRender: 'status' } },
        { title: '领取用户', dataIndex: 'receiveUser', align: '', width: '', scopedSlots: { customRender: 'user' } },
        { title: '领取时间', dataIndex: 'receiveTimeDesc', align: '', width: '' }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined
      },
      listApi: {
        url: '',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        addTitle: '',
        editTitle: ''
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
    this.init();
  },
  mounted () {
    this.$refs.table.getTableList();
  },
  methods: {
    init () {
      this.queryParam = this.$route.query;
      this.infoList[0].value = this.queryParam.name;
      this.infoList[1].value = this.queryParam.expireTime;
      if ([1, '1'].every(item => item !== this.queryParam.status)) { // 0.作废， 1.有效， 2.过期
        this.tableOptList[1].disabled = true;
      } else {
        delete this.tableOptList[1].disabled;
      }

      if ([1, '1'].some(item => item === this.queryParam.type)) {
        this.searchList[0].placeholder = '手机号、卡券';
        this.columns.unshift(...this.couponColumns);
      } else {
        this.searchList[0].placeholder = '卡号';
        this.columns.unshift(...this.pwdColumns);
      }
      this.listApi.url = `/pm/coupon/${this.queryParam.id}`;
      this.addParam.url = `/pm/coupon/list/${this.queryParam.id}`;
    },
    /** 跳转用户详情 */
    toUserDetail (row) {
      this.$router.push({
        name: 'memberDetail',
        query: { id: row.userId, ...this.breadParam(this) }
      });
    },
    /** 导出数据 */
    exportData (ids, rows) {
      this.$post({
        url: `/pm/coupon/export/${this.queryParam.id}`,
        params: {},
        config: { responseType: 'blob' }
      }).catch((res) => {
        let blob = new Blob([res.data], {type: res.headers['content-type']});
        let URL = window.URL || window.webkitURL;
        let objectUrl = URL.createObjectURL(blob);

        let a = document.createElement('a');
        if (typeof a.download === 'undefined') { // safari doesn't support this yet
          window.location = objectUrl;
        } else {
          a.href = objectUrl;
          a.download = `${this.queryParam.name}.xlsx`;
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(objectUrl);
          a.remove();
        }
      });
    },
    /** 添加卡卷 */
    toAddCoupon () {
      const fileItem = this.formList.find(item => item.props && item.props[0] === 'file');
      fileItem.fileList = [];
      this.visible = true;
    },
    /** 下载模板 */
    downTemplate () {
      window.open(process.env.VUE_APP_BASE_API + '/pm/coupon/download');
    },
    /** upload 文件数据 */
    beforeHandle (file, fileList) {
      this.fileData = file;
      const fileItem = this.formList.find(item => item.props && item.props[0] === 'file');
      fileItem.fileList = [{
        uid: file.uid,
        name: file.name,
        url: URL.createObjectURL(file)
      }];

      return false;
    },
    reqHandle (param) {
      const formdata = new FormData();
      formdata.set('file', this.fileData);
      return formdata;
    },
    addResHandle (res) {
      this.visible = false;
      this.$message.success(h => h({
        template: `<div>${res.msg}</div>`
      }));
      this.$refs.table.getTableList();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
